import React, {Component} from "react";
import {
  setBudgetAppTypeFilter,
} from "../../../../actions/actions/eventStats";
import {connect} from "react-redux";
import _ from "i18n";
import {
  generateFollowUp, updateFollowUp
} from "../../../../actions/thunks/eventStats";
import {Icon} from "antd/lib/index";
import FilterModal from "../../../common/BudgetManagement/FilterModal";

@connect(store => ({
  auth: store.auth
}))
class TypeFilter extends Component {

  constructor() {
    super();
    this.state = {
      visible: false,
      nextAppType: '',
    };
  }

   handleDontSaveClick = () => {
    this.props.setBudgetAppTypeFilter(this.state.nextAppType);
     this.setState({visible : false})
  };

  handleSaveClick = () => {
    const {followUp} = this.props.budgetManagement;

    if (followUp.length === 0){
      const {appType, year,budgetPerMonth, globalBudget:{totalHTVA ,registrantsCount, pricePerUnit}} = this.props.budgetManagement;
      this.props.generateFollowUp(appType, year,budgetPerMonth, totalHTVA, registrantsCount, pricePerUnit).then( () => {
          this.props.setBudgetAppTypeFilter(this.state.nextAppType);
          this.setState({visible : false});
      });
    } else  {
      const {annualTargetId, followUp} = this.props.budgetManagement;
      this.props.updateFollowUp(annualTargetId, followUp).then(() => {
        this.props.setBudgetAppTypeFilter(this.state.nextAppType);
        this.setState({visible : false});
      });
    }
  };

  handleCancelClick = () => {
    this.setState({visible : false})
  };

  handleTypeSelect = (appType) => {
    const { followUp, originalFollowUp, budgetPerMonth, originalBudgetPerMonth } = this.props;

    const followUpIsUnchanged = followUp.every((element, index) => element.registrantsCount === originalFollowUp[index].registrantsCount && element.followUpPricePerUnit === originalFollowUp[index].followUpPricePerUnit);
    const budgetPerMonthIsUnchanged = budgetPerMonth.every((element, index) => element.registrantsCount === originalBudgetPerMonth[index].registrantsCount);


    if (followUpIsUnchanged && budgetPerMonthIsUnchanged ) {
      this.props.setBudgetAppTypeFilter(appType);
    } else {
      this.setState({visible : true, nextAppType: appType})
    }
  };

  checkIfAnAppTypeIsConfigured = () => {
    let isConfigured = false;
    const {appTypesAreConfigured} = this.props.budgetManagement;
    for (const prop in appTypesAreConfigured) {
      if (appTypesAreConfigured[prop] === true) {
        isConfigured = true;
      }
    }
    return isConfigured;
  }


  render() {
    const {budgetManagement} = this.props;
    const {visible} = this.state;
    const allTabIsShowed = this.checkIfAnAppTypeIsConfigured();
    const { auth } = this.props;

    const currentClientId = this.props.currentClient.id;
    return (
      <div className={'create-BM-type-filter'}>
        <ul>
          {
            allTabIsShowed === true ?
              <li
                className={budgetManagement.appType === 'all' ? 'event-filter-app-type-all selected' : 'event-filter-app-type-all'}
                onClick={() => this.handleTypeSelect('all')}
              >
                <span>{_('ALL')}</span>
              </li> : null
          }
          <li
            className={budgetManagement.appType === 'registering' ? 'event-filter-app-type-registering selected' : 'event-filter-app-type-registering'}
            onClick={() => this.handleTypeSelect('registering')}
          >
            <span>{_('TRAININGS')}</span>
            {budgetManagement.appTypesAreConfigured.registering === true && <Icon type="check" style={{marginLeft: '5px'}}/>}
          </li>
          {(auth.currentClient.businessType === 'SUPER_CHAIN' || auth.currentClient.businessType === 'MASTER_CHAIN') && (
            <li
            className={budgetManagement.appType === 'cycle' ? 'event-filter-app-type-cycle selected' : 'event-filter-app-type-cycle'}
            onClick={() => this.handleTypeSelect('cycle')}
            >
              <span>{_('CYCLES')}</span>
              {budgetManagement.appTypesAreConfigured.cycle === true && <Icon type="check" style={{marginLeft: '5px'}}/>}
            </li>
          )}
          {auth.currentClient.businessType === 'SUPER_CHAIN' && (
            <React.Fragment>
              <li
                className={budgetManagement.appType === 'cycle_essential' ? 'event-filter-app-type-cycle_essential selected' : 'event-filter-app-type-cycle_essential'}
                onClick={() => this.handleTypeSelect('cycle_essential')}
              >
                <span>{_('CYCLES Essentiel')}</span>
                {budgetManagement.appTypesAreConfigured.cycle_essential === true && <Icon type="check" style={{marginLeft: '5px'}}/>}
              </li>
              <li
                className={budgetManagement.appType === 'all_in' ? 'event-filter-app-type-seasons selected' : 'event-filter-app-type-seasons'}
                onClick={() => this.handleTypeSelect('all_in')}
              >
                <span>{_('SEASONS')}</span>
                {budgetManagement.appTypesAreConfigured.all_in === true && <Icon type="check" style={{marginLeft: '5px'}}/>}
              </li>
              <li
                className={budgetManagement.appType === 'premium' ? 'event-filter-app-type-premium selected' : 'event-filter-app-type-premium'}
                onClick={() => this.handleTypeSelect('premium')}
              >
                <span>PREMIUM</span>
                {budgetManagement.appTypesAreConfigured.premium === true && <Icon type="check" style={{marginLeft: '5px'}}/>}
              </li>

              <li
                className={budgetManagement.appType === 'monthly_premium' ? 'event-filter-app-type-premium selected' : 'event-filter-app-type-premium'}
                onClick={() => this.handleTypeSelect('monthly_premium')}
                style={{marginLeft: "0.5rem"}}
              >
                <span>PREMIUM Mensuel</span>
                {budgetManagement.appTypesAreConfigured.monthly_premium === true && <Icon type="check" style={{marginLeft: '5px'}}/>}
              </li>
            </React.Fragment>
          )}

          {currentClientId === 9 && (
            <li
              className={budgetManagement.appType === 'congres' ? 'event-filter-app-type-congres selected' : 'event-filter-app-type-congres'}
              onClick={() => this.handleTypeSelect('congres')}
              style={{marginLeft: "0.5rem"}}
            >
              <span>{_('CONGRESS')}</span>
              {budgetManagement.appTypesAreConfigured.congres === true && <Icon type="check" style={{marginLeft: '5px'}}/>}
            </li>
          )}
        </ul>
        <FilterModal
          visible={visible}
          budgetManagement={budgetManagement}
          handleDontSaveClick={this.handleDontSaveClick}
          handleSaveClick={this.handleSaveClick}
          handleCancelClick={this.handleCancelClick}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
  followUp: state.budgetManagement.followUp,
  originalFollowUp: state.budgetManagement.originalFollowUp,
  budgetPerMonth: state.budgetManagement.budgetPerMonth,
  originalBudgetPerMonth: state.budgetManagement.originalBudgetPerMonth,
  currentClient: state.auth.currentClient,
});

const mapDispatchToProps = {
  setBudgetAppTypeFilter,
  generateFollowUp,
  updateFollowUp
};

export default connect(mapStateToProps, mapDispatchToProps)(TypeFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/BudgetManagement/TypeFilter.js